// extracted by mini-css-extract-plugin
export var divider = "_rv-0";
export var systemMessage = "_rv-1";
export var systemMessageWrapper = "_rv-2";